export default "__VITE_ASSET__BVQwbDeJ__"